import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAutoCompleteRow from 'components/search/SMAutoCompleteRow';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMConst from 'lib/SMConst';
import SMMapHelper from 'components/helpers/SMMapHelper';

class SMCategorySearchFilterView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      location: this.props.location || '',
      autoCompleteItems : [],
      autoCompleteSelectedRow : 0,
      autoCompleteIsOpen: false,
      amenities: this.props.amenities || '',
      geocode: this.props.geocode || '',
      startedAt: this.props.startedAt || '',
      endedAt: this.props.startedAt || '',
      priceType: this.props.priceType || "hourly,daily,stay",
    };
    this.startDate;
    this.startTime;
    this.endDate;
    this.endTime;
  }

  componentDidMount() {
    $(this.refs.startDatePicker).datepicker({
      minDate: 0,
      dateFormat:"yy/mm/dd",
      onClose: (text)=>{
        this.startDate = text;
        this.startTime = this.startTime || "00:00";
        this.setState({startedAt: SMFormatHelper.searchRangeDateTime(this.startDate, this.startTime)});
      }
    });
    $(this.refs.endDatePicker).datepicker({
      minDate: 0,
      dateFormat:"yy/mm/dd",
      onClose: (text)=>{
        this.endDate = text;
        this.endTime = this.endTime || "00:00";
        this.setState({endedAt: SMFormatHelper.searchRangeDateTime(this.endDate, this.endTime)});
      }
    });
    $(this.refs.priceSlider).slider({
      range: true,
      min: 0,
      max: 100000,
      step: 5000,
      values: [0, 100000],
      slide: (event, ui)=>{
        $(this.refs.minPrice).val(ui.values[0]);
        $(this.refs.maxPrice ).val(ui.values[1]);
      }
    });
    // $(this.refs.minPrice).val($(this.refs.priceSlider).slider("values", 0));
    // $(this.refs.maxPrice).val($(this.refs.priceSlider).slider("values", 1));
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
    // this.autocomplete = new google.maps.places.AutocompleteService();
  }

  locationDidChangeValue(e) {
    const query = e.currentTarget.value;
    if (!query) {
      this.setState({autoCompleteItems: [], autoCompleteIsOpen: false});
      return;
    }

    this.autocomplete.getPlacePredictions({input: query}, (predictions, status) => {
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        console.error(status);
        return;
      }
      let autoCompleteItems = [];
      predictions = SMMapHelper.sortPredictions(predictions);
      predictions.forEach(function(prediction) {
        autoCompleteItems.push(prediction);
      });
      this.setState({
        autoCompleteItems: autoCompleteItems,
        autoCompleteIsOpen: true,
      });
    });
  }

  locationDidStartEditing(e) {
    this.setState({
      autoCompleteIsOpen: true,
    });
  }

  locationDidEndEditing(e) {
    // this.setState({
    //   autoCompleteIsOpen: false,
    // });
  }

  autoCompleteItemDidSelect(i){
    // const item = this.state.autoCompleteItems[i];
    // const displayText = item.terms[0].value;
    // googlePlacesService = new google.maps.places.PlacesService(this.refs.locationField);
    // googlePlacesService.getDetails({placeId:item.place_id}, (details, status)=>{
    //   let state = {
    //     location: item.description,
    //     autoCompleteIsOpen: false,
    //   };
    //   if(details){
    //     const l = details.geometry.location;
    //     const vp = details.geometry.viewport;
    //     const radius = SMMapHelper.getRadiusByViewport(vp);
    //     state.geocode = SMMapHelper.getGeocode(l.lat(), l.lng(), radius);
    //     this.refs.locationField.value = displayText;
    //   }
    //   this.setState(state);
    // });
  }

  autoCompleteDidHide() {
    this.setState({autoCompleteIsOpen: false});
  }

  autoCompleteDidChangeRow(row){
    this.setState({autoCompleteSelectedRow: row});
  }

  formDidSubmit(e) {
    //e.preventDefault();
  }

  amenityDidSelect(e){
    let amenities = this.state.amenities != "" ? this.state.amenities.split(",") : [];
    const value = e.currentTarget.value;
    let existIndex = amenities.indexOf(value);
    if (existIndex == -1) amenities.push(value);
    else amenities.splice(existIndex, 1);

    this.setState({
      amenities: amenities.join(",")
    });
  }

  startTimeDidSelect(e){
    this.startTime = e.currentTarget.value;
    if (this.startDate) {
      this.setState({startedAt: SMFormatHelper.searchRangeDateTime(this.startDate, this.startTime)});
    }
  }

  endTimeDidSelect(e){
    this.endTime = e.currentTarget.value;
    if (this.endDate) {
      this.setState({endedAt: SMFormatHelper.searchRangeDateTime(this.endDate, this.endTime)});
    }
  }

  rentTypeDidChange(e) {
    const value = e.currentTarget.value;
    let types = this.state.priceType == "" ? [] :this.state.priceType.split(",");
    const index = types.indexOf(value);
    if (index != -1) types.splice(index, 1);
    else types.push(value);
    this.setState({priceType: types.join(",")});
  }

  render() {
    return(
      <div className="site-sidebar sm-hide">
        <h2 className="site-sidebar__headline">詳細検索</h2>
        <form ref="form" method="get" action={Routes.search_index_path()}>
          <div className="site-sidebar__inner">
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">目的</h3>
              <label className="lpsearch-sidebar__purpose mr4pa">
                <span className="service-select">
                  <select name="event_type" defaultValue={this.props.eventType} className="service-select__purpose w100pa">
                    {SMRenderHelper.renderEventTypeOptions(this.props.eventTypeList)}
                  </select>
                </span>
              </label>
            </div>
            <div className="site-sidebar__section clearfix">
              <input type="hidden" name="geocode" value={this.state.geocode} />
              <input type="hidden" name="medium_location" value={this.props.mediumLocation || ''} />
              <h3 className="site-sidebar__section-title">エリア</h3>
              <input type="text" name="location"
                ref="locationField"
                aria-haspopup="false"
                aria-autocomplete="both"
                spellCheck="false"
                autoComplete="off"
                defaultValue={this.state.location}
                onFocus={this.locationDidStartEditing.bind(this)}
                onBlur={this.locationDidEndEditing.bind(this)}
                onChange={this.locationDidChangeValue.bind(this)}
                className="form-text servicse-form-text w100pa"
                placeholder={I18n.t("service.text_000004")} />
              <SMAutoCompleteRow
                isOpen={this.state.autoCompleteIsOpen}
                items={this.state.autoCompleteItems}
                selectedRow={this.state.autoCompleteSelectedRow}
                delegate={this}
                 />
            </div>
            <input type="hidden" name="capacity" value={this.props.capacity} />
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">人数</h3>
              <label className="lpsearch-sidebar__person-num">
                <span className="search-change__label">最小人数</span>
                <span className="service-select">
                  <select name="min_capacity" className="service-select__person-num w100pa" defaultValue={this.props.minCapacity}>
                    {(()=>{
                      let options = [
                        <option key="0" value="1">1人</option>
                      ];
                      this.props.capacityList.forEach((capacity)=>{
                        options.push(
                          <option key={capacity.id} value={capacity.name}>{capacity.name}人</option>
                        );
                      });
                      return options;
                    })()}
                  </select>
                </span>
              </label>
              <span className="lpsearch-box__while-txt">〜</span>
              <label className="lpsearch-sidebar__person-num">
                <span className="search-change__label">最大人数</span>
                <span className="service-select">
                  <select name="max_capacity" className="service-select__person-num w100pa" defaultValue={this.props.maxCapacity}>
                    {(()=>{
                      let options = [
                        <option key="none" value="">{I18n.t('service.label_000047')}</option>,
                      ];
                      this.props.capacityList.forEach((capacity)=>{
                        options.push(
                          <option key={capacity.id} value={capacity.name}>{capacity.name}人</option>
                        );
                      });
                      return options;
                    })()}
                  </select>
                </span>
              </label>
            </div>
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">キーワード</h3>
              <input type="text" name="keyword" defaultValue={this.props.keyword} className="form-text servicse-form-text w100pa" placeholder="例：古民家 開発合宿" />
            </div>
            {/* <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">ご利用予定日</h3>
              <div className="lpsearch-sidebar__date-checkin clearfix">
                <label className="lpsearch-sidebar__date-calender mr2pa">
                  <span className="search-change__label">ご利用開始日(チェックイン)</span>
                  <input type="text" ref="startDatePicker" className="datepicker form-text servicse-form-text w100pa" placeholder="カレンダーから選択" readOnly={true} />
                  <input type="hidden" name="started_at" value={this.state.startedAt} />
                </label>
                <label className="lpsearch-sidebar__date-time">
                  <span className="search-change__label">時間</span>
                    <span className="service-select">
                      <select onChange={this.startTimeDidSelect.bind(this)} className="service-select__purpose w100pa">
                        {SMRenderHelper.renderTimeOptions()}
                      </select>
                    </span>
                </label>
              </div>
              <div className="lpsearch-sidebar__date-checkout clearafix">
                <label className="lpsearch-sidebar__date-calender mr2pa">
                  <span className="search-change__label">ご利用終了日(チェックアウト)</span>
                  <input type="text" ref="endDatePicker" className="datepicker form-text servicse-form-text w100pa" placeholder="カレンダーから選択" readOnly={true} />
                  <input type="hidden" name="ended_at" value={this.state.endedAt} />
                </label>
                <label className="lpsearch-sidebar__date-time">
                  <span className="search-change__label">時間</span>
                    <span className="service-select">
                      <select onChange={this.endTimeDidSelect.bind(this)} className="service-select__purpose w100pa">
                        {SMRenderHelper.renderTimeOptions()}
                      </select>
                    </span>
                </label>
              </div>
            </div> */}
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">予算</h3>
              <div className="lpsearch-sidebar__slider__area js-slider__horizontal">
                <div id="js-slider__range" ref="priceSlider"></div>
                <div className="search-slider__pricebox clearfix">
                  <div className="fl">
                    <input type="number" name="min_price" placeholder="0" defaultValue={this.props.minPrice} ref="minPrice" className="search-slider__input" /><span className="search-slider__price">円〜</span>
                  </div>
                  <div className="fr">
                    <input type="number" name="max_price" placeholder="50000" defaultValue={this.props.maxPrice} ref="maxPrice" className="search-slider__input" /><span className="search-slider__price">円</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="lpsearch-sidebar__section-amenity clearfix">
              <h3 className="site-sidebar__section-title">アメニティ</h3>
              <div className="row lpsearch-sidebar__amenity">
                {SMRenderHelper.renderAmenityCheckBoxes(
                  this.props.amenityList,
                  SMConst.AmenityType.All,
                  this.state.amenities,
                  this.amenityDidSelect.bind(this),
                  "col-md-6"
                )}
                <input type="hidden" name="amenities" value={this.state.amenities} />
              </div>
              {/*<div className="lpsearch-sidebar__amenity-more">
                <a href="#">もっと見る</a>
              </div>*/}
            </div>
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-subtitle">宿泊</h3>
              <div className="row lpsearch-sidebar__amenity">
                {SMRenderHelper.renderAmenityCheckBoxes(
                  this.props.amenityList,
                  SMConst.AmenityType.Stay,
                  this.state.amenities,
                  this.amenityDidSelect.bind(this),
                  "col-md-6"
                )}
              </div>
              {/*<div className="lpsearch-sidebar__amenity-more">
                <a href="#">もっと見る</a>
              </div>*/}
            </div>
            <div className="site-sidebar__section clearfix">
              <h3 className="site-sidebar__section-title">スペースタイプ</h3>
              <span className="service-select">
                <select name="space_type" defaultValue={this.props.spaceType} className="service-select__purpose w100pa">
                  {SMRenderHelper.renderSpaceTypeOptions(this.props.spaceTypeList)}
                </select>
              </span>
            </div>

            <div className="ta-c">
              <input className="button-blue pt15 pb15 w200" type="submit" value="検索する" />
            </div>
          </div>
          <input type="hidden" name="with_recommend" value={true} />
        </form>
      </div>
    );
  }
}
export default SMCategorySearchFilterView;




// WEBPACK FOOTER //
// ./app/javascript/components/categories/SMCategorySearchFilterView.jsx